import {AfterContentChecked, AfterViewInit, Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {ServicesService} from '../services.service';
import {environment} from '../../environments/environment';

@Component({
  selector: 'app-make-payment',
  templateUrl: './make-payment.component.html',
  styleUrls: ['./make-payment.component.css']
})
export class MakePaymentComponent implements OnInit , AfterViewInit, AfterContentChecked {

    header = 'l-header';
    navbar = 'l-navbar l-navbar_t-light l-navbar_expand js-navbar-sticky';
    wpwlOptions = {style: 'card'};
    checkoutId;
    webBaseUrl: string        = environment.webBaseUrl;
    apiBaseUrl: string        = environment.apiBaseUrl;
    // shopperResultUrl = this.webBaseUrl + '/orderprocessing';
    shopperResultUrl = this.apiBaseUrl + '/api/payment/response';
    paymentUrl = environment.paymentUrl;
    amount = 0;

    payment_msg = 'Please do not refresh the page and wait while we are processing your payment.';
    constructor(private route: ActivatedRoute, private _service: ServicesService, private router: Router) {
    }

    ngOnInit() {
        this.getorderPrice();
        this.getCheckout();
    }
    ngAfterViewInit() {
        // $('.tb-preloader-wave').fadeOut();
        // $('#tb-preloader').delay(200).fadeOut('slow').remove();
    }
    ngAfterContentChecked() {
        // $('.tb-preloader-wave').fadeOut();
        // $('#tb-preloader').delay(200).fadeOut('slow').remove();

    }
    getorderPrice() {
        const userData = JSON.parse(localStorage.getItem('userData'));
        const token = localStorage.getItem('userToken');

        const user_id = userData.hasOwnProperty('id') ? userData.id : '';
        const data = {'token': token };
        this._service.getorderPrice(data).subscribe((res: any) => {
            if (res.status === 200) {
                this.amount = res.result;
            }else {
                // this.router.navigate(['login']);
            }
        });
    }

    getCheckout() {
        const userData = JSON.parse(localStorage.getItem('userData'));
        const token = localStorage.getItem('userToken');

        const user_id = userData.hasOwnProperty('id') ? userData.id : '';
        const data = {'token': token};
        this._service.getCheckout(data).subscribe((res: any) => {
            // console.log('getCheckout', res);
            if (res.status === 200) {
                this.checkoutId = res.result;
                this.loadScript();
            }else {
                $('.tb-preloader-wave').fadeOut();
                $('#tb-preloader').delay(200).fadeOut('slow').remove();
                this.payment_msg = 'Payment is down, please try after sometime';
            }

        },
            err => {
                $('.tb-preloader-wave').fadeOut();
                $('#tb-preloader').delay(200).fadeOut('slow').remove();
                this.payment_msg = 'Something went wrong please refresh';
            }
        );
    }

    loadScript() {
        const node = document.createElement('script');
        node.src = this.paymentUrl + '/v1/paymentWidgets.js?checkoutId=' + this.checkoutId;
        node.type = 'text/javascript';
        node.async = false;
        node.charset = 'utf-8';
        document.getElementsByTagName('head')[0].appendChild(node);
        setTimeout(() => {
            $('.tb-preloader-wave').fadeOut();
            $('#tb-preloader').delay(200).fadeOut('slow').remove();

            document.getElementById('loader').style.display = 'none';
        }, 1500);

    }
}



// WEBPACK FOOTER //
// /var/www/html/oneills-web-qa/src/app/make-payment/make-payment.component.ts